'use client'

import { usePathname } from 'next/navigation'

import { BookingProgressBar } from '@/src/components/layout/BookingProgressBar'
import { WizardLayout } from '@/src/components/wizard/WizardLayout'
import { bookingWorkerFlow } from '@/src/config/flows/booking-worker.flow'
import { getGroupForStep, getMainStepCount } from '@/src/lib/flow-engine/types'
import { useWorkerBookingStore } from '@/src/lib/store/workerBookingStore'

export default function BookingWorkerLayout({ children }: { children: React.ReactNode }) {
  const { currentStep } = useWorkerBookingStore()
  const pathname = usePathname()
  const safePathname = pathname ?? ''
  const isSuccessPage = safePathname.endsWith('/success') || safePathname.endsWith('/success/')

  return (
    <WizardLayout
      progressBar={
        isSuccessPage ? undefined : (
          <BookingProgressBar
            currentStep={getGroupForStep(bookingWorkerFlow, currentStep)}
            totalSteps={getMainStepCount(bookingWorkerFlow)}
          />
        )
      }
    >
      {children}
    </WizardLayout>
  )
}
